import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import workoutSlice from '../features/add_workout/workoutSlice';
import authenticationSlice from '../features/authentication/authenticationSlice';
import ParticipantDirectorySlice from '../features/ParticipantDirectory/ParticipantDirectorySlice';

export const store = configureStore({
  reducer: {
    Workout:workoutSlice,
    Login:authenticationSlice,
    ParticipantDirectory:ParticipantDirectorySlice,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
